import { IApplicationState } from '../../../../../../../types/types';
import { getCardComments } from '../../../../../../../store/model/selectors/getCardComments';
import { connect } from 'react-redux';
import { ITabTimingCommentsListHOCProps } from './types';
import { onEdit } from './events/onEdit';
import {
    ECommentListDirection,
    ICommentsListEvents,
    ICommentsListFields
} from '../../../../../base/components/Comments/components/CommentsList/types';
import { getBoardIdByCardId } from '../../../../../../../store/model/selectors/getBoardIdByCardId';
import { CommentsList } from '../../../../../base/components/Comments/components/CommentsList/CommentsList';
import { getCard } from '../../../../../../../store/model/selectors/getCard';
import { onLoad } from './events/onLoad';
import { EUserSettingsCommentSort } from '../../../../../../../types/rest/IRestAuthUser';
import {
    getAuthUserSettingsCommentsSort
} from '../../../../../../../store/model/authUser/selectors/getAuthUserSettingsCommentsSort';

const mapStateToProps = (
    state: IApplicationState,
    ownProps: ITabTimingCommentsListHOCProps
): ICommentsListFields => {
    const {cardId} = ownProps;
    const comments = getCardComments(state, cardId)
        .filter(comment => comment.timeTracker)
        .sort((a, b) => b.created - a.created);
    const { commentCount } = getCard(state, cardId);
    const sort = getAuthUserSettingsCommentsSort(state);

    return {
        ascOrder: sort === EUserSettingsCommentSort.ASC,
        cardId,
        boardId: getBoardIdByCardId(state, cardId),
        comments,
        commentCount: commentCount,
        direction: ECommentListDirection.DOWN,
        isReadonly: true
    };
};

const mapDispatchToProps = (
    dispatch: any,//todo check Dispatch not work
    { cardId }: ITabTimingCommentsListHOCProps,
): ICommentsListEvents => {
    return {
        onEdit: () => dispatch(onEdit()),
        onLoad: () => dispatch(onLoad(cardId)),
    };
};

export const TabTimingCommentsListHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CommentsList);

TabTimingCommentsListHOC.displayName = 'CommentsListHOC';
